import { toNorwegianTime } from './dateUtils'

export const formatDate = (dateString: string): string => {
  return new Intl.DateTimeFormat('nb-NO', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'Europe/Oslo'
  }).format(toNorwegianTime(dateString))
}

export const formatDateShort = (dateString: string): string => {
  return new Intl.DateTimeFormat('nb-NO', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'Europe/Oslo'
  }).format(toNorwegianTime(dateString))
}

export const formatTime = (dateString: string): string => {
  return new Intl.DateTimeFormat('nb-NO', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/Oslo'
  }).format(toNorwegianTime(dateString))
}

export const formatPrice = (price: number): string => {
  const formattedNumber = new Intl.NumberFormat('nb-NO', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);
  return `${formattedNumber},-`;
}
